import { render, staticRenderFns } from "./CallMessage.vue?vue&type=template&id=0b289b8f&"
import script from "./CallMessage.vue?vue&type=script&lang=js&"
export * from "./CallMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports